import { Box, CircularProgress, styled, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormik } from "formik";
import { useEffect, useMemo, useState } from "react";
import { UploadIcon } from "../../assets/Icon/dashboredIcon";
import { PhoneIcon } from "../../assets/Icon/LlcForm";
import CommonRadioButton from "../../components/common-components/CommonRadioButton";
import CustomButton from "../../components/common-components/CustomButton";
import FormInputField from "../../components/common-components/FormInputField";
import {
  annual_revenue,
  employees_count,
  member,
} from "../../components/common-components/SelectData";
import SelectInputField from "../../components/common-components/SelectInputField";
import TitleBar from "../../components/common-components/TitleBar";
import { StyledTypographyLLc } from "../../components/style/modalStyle";
import { llcSchema, memberSchema } from "../../form-schema";

import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UploadFileFieldNew from "../../components/common-components/UploadFileFieldNew";
import {
  createIncorpartion,
  getCompanyTypeList,
  getCountryList,
  getIncorporationList,
  getIndustryData,
  getStateList,
} from "../../stores/incorporation";
import { useAppDispatch } from "../../stores/store";
import { setToast } from "../../stores/toast/toastslice";
import { buildMemberPassportPayload } from "../../utils/incorporationMemberPassports";

import CustomButtonFormStep from "../../components/common-components/CustomButtonStepperForm";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import CustomModal from "../../components/common-components/CustomModal";
import MemberAttachmentModal from "../../components/common-components/AddMemberComponent";
interface IncorporationDetails {
  scan_passport?: File | null | string;
  [key: string]: any | null;
}

const Incorporation = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();
  const isViewMode = location.pathname.includes("view");
  const isEditMode = location.pathname.includes("edit");
  const [openMemberModal, setOpenMemberModal] = useState(false);
  const [apiErrors, setApiErrors] = useState<any[]>([]);
  const [isEditing, setIsEditing] = useState(!isViewMode);
  const [filePreview, setFilePreview] = useState<string | null>("");
  const redirect = () => navigate("/incorporation");
  const {
    incorporationDetails,
    countryList,
    industryList,
    compnayTypeList,
    stateList,
    status,
  } = useSelector((store: any) => store.incorporation);

  const [loading, setLoading] = useState(false);
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [getLoading, setGetLoading] = useState(true);
  const [memberPassports, setMemberPassports] = useState<
    (File | string | null)[]
  >([]);
  const [memberFilePreview, setMemberFilePreview] = useState<string | null>("");
  const [editingMemberIndex, setEditingMemberIndex] = useState<number | null>(
    null,
  );
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState<number>(1);

  const getUpdatedValues = (currentValues: any, initialValues: any) => {
    const updatedValues: any = {};

    Object.entries(currentValues).forEach(([key, value]) => {
      const initialValue = initialValues[key];

      if (key === "scan_passport") {
        if (value instanceof File) {
          updatedValues[key] = value;
        }
      } else if (value !== initialValue) {
        updatedValues[key] = value;
        return;
      }
    });

    return updatedValues;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await dispatch<any>(
          getIncorporationList({ order_id: id }),
        ).unwrap();

        if (response?.status >= 400) {
          await dispatch<any>(
            setToast({
              message:
                response?.data?.statusText ||
                (typeof response?.data?.detail === "string" &&
                  response?.data?.detail) ||
                "Something went wrong!",
              type: "error",
              title: "Error",
            }),
          );
          const timeout = setTimeout(() => {
            redirect();
          }, 2000);

          return () => clearTimeout(timeout);
        }

        setLoading(false);
        setGetLoading(false);
      } catch (err) {
        // redirect();
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (incorporationDetails) {
      if (incorporationDetails.scan_passport) {
        setFilePreview(incorporationDetails.scan_passport || "");
      } else {
        setFilePreview("");
      }

      if (incorporationDetails.additional_members) {
        const initialPassports = incorporationDetails.additional_members.map(
          (m: any) => m.scan_passport || null,
        );
        setMemberPassports(initialPassports);
      }
    }
  }, [incorporationDetails]);

  const handleMemberFileChange = (file: File | null) => {
    formik.setFieldValue("member_attachment", file);
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setMemberFilePreview(previewURL);
    } else {
      setMemberFilePreview("");
    }
  };

  const handleOpenAddModal = () => {
    setEditingMemberIndex(null);
    setMemberFilePreview("");
    // Reset values
    const resetFields: Record<string, any> = {
      member_id: null,
      member_first_name: "",
      member_middle_name: "",
      member_last_name: "",
      member_phone_number: "",
      member_country_code: "",
      member_email: "",
      member_address: "",
      member_city: "",
      member_state: "",
      member_zip_code: "",
      member_country: "",
      member_attachment: null,
    };
    Object.keys(resetFields).forEach((key) => {
      formik.setFieldValue(key, resetFields[key]);
      formik.setFieldTouched(key, false, false);
      formik.setFieldError(key, undefined);
    });
    setOpenMemberModal(true);
  };

  const handleOpenEditModal = (index: number) => {
    const member = formik.values.additional_members[index];
    setEditingMemberIndex(index);

    // Clear previous touched/errors first
    const memberFieldKeys = [
      "member_id",
      "member_first_name",
      "member_middle_name",
      "member_last_name",
      "member_phone_number",
      "member_country_code",
      "member_email",
      "member_address",
      "member_city",
      "member_state",
      "member_zip_code",
      "member_country",
      "member_attachment",
    ];
    memberFieldKeys.forEach((key) => {
      formik.setFieldTouched(key, false, false);
      formik.setFieldError(key, undefined);
    });

    formik.setFieldValue("member_id", member.id || member.member_id || null);
    formik.setFieldValue("member_first_name", member.first_name);
    formik.setFieldValue("member_middle_name", member.middle_name);
    formik.setFieldValue("member_last_name", member.last_name);
    formik.setFieldValue("member_phone_number", member.phone_number);
    formik.setFieldValue("member_email", member.email);
    formik.setFieldValue("member_address", member.address);
    formik.setFieldValue("member_city", member.city);
    formik.setFieldValue("member_state", member.state);
    formik.setFieldValue("member_zip_code", member.zip_code);
    formik.setFieldValue("member_country", member.country);
    formik.setFieldValue("member_country_code", member.country_code);
    formik.setFieldValue("member_attachment", memberPassports[index]);

    if (memberPassports[index]) {
      if (memberPassports[index] instanceof File) {
        setMemberFilePreview(
          URL.createObjectURL(memberPassports[index] as File),
        );
      } else {
        setMemberFilePreview(memberPassports[index] as string);
      }
    } else {
      setMemberFilePreview("");
    }

    setOpenMemberModal(true);
  };

  const handleSaveMember = async () => {
    
    const memberFields = {
      member_first_name: formik.values.member_first_name,
      member_middle_name: formik.values.member_middle_name,
      member_last_name: formik.values.member_last_name,
      member_email: formik.values.member_email,
      member_phone_number: formik.values.member_phone_number,
      member_address: formik.values.member_address,
      member_city: formik.values.member_city,
      member_state: formik.values.member_state,
      member_zip_code: formik.values.member_zip_code,
      member_country: formik.values.member_country,
      member_attachment: formik.values.member_attachment,
    };

    // Touch all member fields to trigger error display
    const memberFieldKeys = Object.keys(memberFields);
    memberFieldKeys.forEach((key) => formik.setFieldTouched(key, true, false));

    try {
      await memberSchema.validate(memberFields, { abortEarly: false });
    } catch (err: any) {
      // Set formik errors for each member field
      err.inner?.forEach((error: any) => {
        formik.setFieldError(error.path, error.message);
      });
      return; // Stop — do not save
    }

    const newMember = {
      member_id: formik.values.member_id,
      first_name: formik.values.member_first_name,
      middle_name: formik.values.member_middle_name,
      last_name: formik.values.member_last_name,
      phone_number: formik.values.member_phone_number,
      email: formik.values.member_email,
      address: formik.values.member_address,
      city: formik.values.member_city,
      state: formik.values.member_state,
      zip_code: formik.values.member_zip_code,
      country: formik.values.member_country,
      country_code: formik.values.member_country_code,
    };

    const updatedMembers = [...formik.values.additional_members];
    const updatedPassports = [...memberPassports];

    if (editingMemberIndex !== null) {
      updatedMembers[editingMemberIndex] = newMember;
      updatedPassports[editingMemberIndex] = formik.values.member_attachment;
    } else {
      updatedMembers.push(newMember);
      updatedPassports.push(formik.values.member_attachment);
    }

    formik.setFieldValue("additional_members", updatedMembers);
    setMemberPassports(updatedPassports);
    if (editingMemberIndex !== null) {
      updatedMembers[editingMemberIndex] = newMember;
      updatedPassports[editingMemberIndex] = formik.values.member_attachment;

      // Remove only fixed member error
      setApiErrors((prev: any) =>
        prev.filter((err: any) => err.member !== editingMemberIndex + 1),
      );
    }
    setOpenMemberModal(false);
  };

  const handleDeleteMember = (index: number) => {
    const updatedMembers = formik.values.additional_members.filter(
      (_: any, i: number) => i !== index,
    );
    const updatedPassports = memberPassports.filter(
      (_: any, i: number) => i !== index,
    );
    formik.setFieldValue("additional_members", updatedMembers);
    setMemberPassports(updatedPassports);
    setApiErrors([]);
  };

  const handleFileChange = (file: File | null) => {
    formik.setFieldValue("scan_passport", file);
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setFilePreview(previewURL);
    } else {
      setFilePreview("");
    }
  };

  const handleSubmit = async (values: typeof formik.values) => {
    // industry_category is derived for the UI only, so a back-filled category
    // must not read as an unsaved edit.
    const withoutUiOnlyFields = ({ industry_category, ...rest }: any) => rest;
    const hasFormValueChanges =
      JSON.stringify(withoutUiOnlyFields(values)) !==
      JSON.stringify(withoutUiOnlyFields(formik.initialValues));
    const hasMemberPassportUploads = memberPassports.some(
      (passport) => passport instanceof File,
    );

    if (!hasFormValueChanges && !hasMemberPassportUploads) {
      setTimeout(() => {
        navigate(`/incorporation-detail/${id}`);
      }, 400);
      return;
    }

    setSubmissionLoading(true);
    setApiErrors([]);

    // Validate form
    const errors = await formik.validateForm();

    formik.setTouched(
      Object.keys(formik.initialValues).reduce(
        (acc, key) => ({
          ...acc,
          [key]: true,
        }),
        {},
      ),
    );

    // Stop if form has validation errors
    if (Object.keys(errors).length > 0) {
      setSubmissionLoading(false);
      return;
    }

    // Check members
    if (
      values.company_members === "Multimember" &&
      values.additional_members?.length === 0
    ) {
      dispatch<any>(
        setToast({
          message: "Please add at least one member.",
          type: "error",
          title: "Error",
        }),
      );

      setSubmissionLoading(false);
      return;
    }

    const updatedValues = getUpdatedValues(values, formik.initialValues);

    const formData = new FormData();

    Object.entries(updatedValues).forEach(([key, value]) => {
      if (key === "additional_members") {
        formData.append(key, JSON.stringify(value));
      } else if (key.startsWith("member_")) {
        // skip temp member fields
      } else if (key === "industry_category") {
        // UI-only field; the backend stores the child id in industry_type
      } else if (typeof value === "string") {
        formData.append(key, value.trim());
      } else if (value !== null && value !== undefined) {
        formData.append(key, value as Blob);
      }
    });

    const { files: memberPassportFiles, indices, needsIndices } =
      buildMemberPassportPayload(
        values.additional_members ?? [],
        memberPassports,
      );

    memberPassportFiles.forEach((file) => {
      formData.append("member_passports", file);
    });

    if (memberPassportFiles.length > 0 && needsIndices) {
      formData.append("member_passport_indices", JSON.stringify(indices));
      // Full member list must align with indices when only passports changed (no diff in additional_members).
      if (!Object.prototype.hasOwnProperty.call(updatedValues, "additional_members")) {
        formData.append(
          "additional_members",
          JSON.stringify(values.additional_members ?? []),
        );
      }
    }

    if (id) {
      formData.append("order_id", id);
    }

    try {
      const response = await dispatch<any>(
        createIncorpartion(formData),
      ).unwrap();

      console.log("FULL API RESPONSE =>", response?.data?.errors || response);
      setApiErrors(response?.data?.errors);
      // Check for errors in different possible response structures
      const responseErrors =
        response?.data?.errors ||
        response?.errors ||
        (Array.isArray(response) ? response : null);
      const isError =
        response?.code >= 400 ||
        response?.status === 0 ||
        response?.data?.code >= 400 ||
        (responseErrors && responseErrors.length > 0);

      // API Error
      if (isError) {
        console.log("API ERROR =>", response);

        setApiErrors(responseErrors || []);

        dispatch<any>(
          setToast({
            message:
              response?.data?.message ||
              response?.message ||
              "Something went wrong!",
            type: "error",
            title: "Error",
          }),
        );

        setSubmissionLoading(false);
        return;
      }

      // Success
      if (response?.status === 1) {
        dispatch<any>(
          setToast({
            message: response?.message || "Form submitted successfully!",
            type: "success",
            title: "Success",
          }),
        );

        setFilePreview("");

        formik.resetForm();

        setTimeout(() => {
          navigate(`/incorporation-detail/${id}`);
        }, 400);
      } else {
        const fallbackErrors =
          response?.data?.errors ||
          response?.errors ||
          (Array.isArray(response) ? response : []);
        setApiErrors(fallbackErrors);
        console.log(apiErrors, "apiErrors");
        dispatch<any>(
          setToast({
            message:
              response?.data?.message ||
              response?.message ||
              "Something went wrong!",
            type: "error",
            title: "Error",
          }),
        );
      }
    } catch (error: any) {
      const apiResponse = error?.data || error?.response?.data;

      setApiErrors(apiResponse?.errors || []);

      dispatch<any>(
        setToast({
          message: apiResponse?.message || "Submission failed!",
          type: "error",
          title: "Error",
        }),
      );
    } finally {
      setSubmissionLoading(false);
    }
  };

  const formik: any = useFormik({
    initialValues: incorporationDetails
      ? {
          ...incorporationDetails,
          preferred_name_1: incorporationDetails.preferred_name_1 || "",
          preferred_name_2: incorporationDetails.preferred_name_2 || "",
          preferred_name_3: incorporationDetails.preferred_name_3 || "",
          middle_name: incorporationDetails.middle_name || "",
          annual_revenue: incorporationDetails?.annual_revenue || "",
          website_name: incorporationDetails?.website_name || "",
          state: incorporationDetails?.state || null,
          scan_passport: incorporationDetails?.scan_passport,
          business_description:
            incorporationDetails?.business_description || "",
          industry_category: incorporationDetails?.industry_parent_id ?? null,
        }
      : {
          first_name: "",
          middle_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          address: "",
          country: "",
          country_code: "",
          city: "",
          state: "",
          zip_code: "",
          company_members: null,
          company_type: null,
          preferred_name_1: "",
          preferred_name_2: "",
          preferred_name_3: "",
          industry_category: null,
          industry_type: null,
          business_description: "",
          genrating_revenue: null,
          annual_revenue: "",
          employees_count: "",
          is_us_company: null,
          website_name: "",
          scan_passport: null,
          additional_members: [],
          member_id: null,
          member_first_name: "",
          member_middle_name: "",
          member_last_name: "",
          member_phone_number: "",
          member_email: "",
          member_address: "",
          member_city: "",
          member_state: "",
          member_zip_code: "",
          member_country: "",
          member_country_code: "",
          member_attachment: null,
        },
    enableReinitialize: true,
    validationSchema: llcSchema,
    validate: (values: any) => {
      const errors: any = {};
      if (openMemberModal) {
        try {
          memberSchema.validateSync(values, { abortEarly: false });
        } catch (err: any) {
          err.inner?.forEach((error: any) => {
            errors[error.path] = error.message;
          });
        }
      }
      return errors;
    },
    onSubmit: handleSubmit,
  });

  // Industry is a two-level menu: the first dropdown lists the top-level
  // categories, the second lists the children of the picked category. Only the
  // child id is persisted (industry_type); the category is UI-only state.
  const industryCategories = useMemo(
    () =>
      (industryList || []).filter(
        (item: any) => item?.parent_id === null || item?.parent_id === undefined,
      ),
    [industryList],
  );

  const industrySubOptions = useMemo(() => {
    const categoryId = formik.values.industry_category;
    if (categoryId === null || categoryId === undefined || categoryId === "") {
      return [];
    }
    return (industryList || []).filter(
      (item: any) => String(item?.parent_id) === String(categoryId),
    );
  }, [industryList, formik.values.industry_category]);

  // The API supplies industry_parent_id directly, so this is only a fallback for
  // rows where it is absent — including legacy rows whose industry_type is
  // itself a top-level industry, which becomes the category with no sub chosen.
  useEffect(() => {
    if (!industryList?.length) return;
    if (formik.values.industry_category) return;
    if (!formik.values.industry_type) return;

    const selected = industryList.find(
      (item: any) => String(item?.id) === String(formik.values.industry_type),
    );
    if (!selected) return;

    formik.setFieldValue("industry_category", selected.parent_id ?? selected.id);

    // A top-level id is not a valid Sub Industry option, so clear it rather than
    // let the sub dropdown fall back to rendering the raw id.
    if (!selected.parent_id) {
      const hasChildren = industryList.some(
        (item: any) => String(item?.parent_id) === String(selected.id),
      );
      if (hasChildren) {
        formik.setFieldValue("industry_type", null);
      }
    }
  }, [industryList, formik.values.industry_type, formik.values.industry_category]);

  const handleIndustryCategoryChange = (categoryId: any) => {
    const children = (industryList || []).filter(
      (item: any) => String(item?.parent_id) === String(categoryId),
    );
    // A category with no children is itself the selectable industry.
    formik.setFieldValue(
      "industry_type",
      children.length === 0 ? categoryId : null,
    );
  };

  const countryData = async () => {
    try {
      const { payload } = await dispatch<any>(getCountryList({}));
    } catch (error) {}
  };

  useEffect(() => {
    dispatch<any>(getIndustryData({}));
    dispatch<any>(getCompanyTypeList({}));
    countryData();
    dispatch<any>(getStateList({}));
  }, []);

  useEffect(() => {
    if (incorporationDetails?.country && incorporationDetails?.state) {
      formik.setFieldValue("state", incorporationDetails.state);
    } else if (formik.values.country || formik.values.country === 233) {
      formik.setFieldValue("state", "");
    } else {
      formik.setFieldValue("state", "");
    }
    if (incorporationDetails?.country !== formik.values.country) {
      formik.setFieldValue("state", "");
    }
  }, [incorporationDetails, formik.values.country]);

  useEffect(() => {
    if (
      incorporationDetails?.genrating_revenue &&
      incorporationDetails?.annual_revenue
    ) {
      formik.setFieldValue(
        "annual_revenue",
        incorporationDetails.annual_revenue,
      );
    } else if (formik.values.genrating_revenue) {
      formik.setFieldValue("annual_revenue", "");
    } else {
      formik.setFieldValue("annual_revenue", "");
    }
    if (
      incorporationDetails?.genrating_revenue !==
      formik.values.genrating_revenue
    ) {
      formik.setFieldValue("annual_revenue", "");
    }
  }, [incorporationDetails, formik.values.genrating_revenue]);

  // useEffect(() => {
  //   if (formik.values.company_members === "Multimember") {
  //     setOpenMemberModal(true);
  //   }
  // }, [formik.values.company_members]);
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
        </div>
      </div>
    );
  }
  // const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   formik.setFieldValue("company_members", e.target.value);

  //   if (e.target.value === "Multimember") {
  //     setOpenMemberModal(true);
  //   }
  // };
  const handleModalClose = () => {
    setOpenMemberModal(false);
  };

  return getLoading ? (
    <>
      <ListLoadingNew />
    </>
  ) : (
    <>
      {currentStep === 1 && (
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <TitleBar title="LLC Form" />
            {isViewMode && !isEditing && incorporationDetails?.status < 2 && (
              <CustomButton
                btnTitle={"Edit"}
                minwidth="191px"
                type="button"
                loading={loading}
                handleClick={() => setIsEditing(true)}
              />
            )}
          </Box>

          <form onSubmit={formik.handleSubmit}>
            <StyledGrid container spacing={2}>
              <Grid size={{ xs: 12, md: 4 }}>
                <FormInputField
                  placeholder="Enter first name"
                  formik={formik}
                  name="first_name"
                  label="First Name"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <FormInputField
                  placeholder="Enter middle name"
                  formik={formik}
                  name="middle_name"
                  label="Middle Name"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <FormInputField
                  placeholder="Enter last name"
                  formik={formik}
                  name="last_name"
                  label="Last Name"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <FormInputField
                  placeholder="Enter phone number"
                  formik={formik}
                  name="phone_number"
                  icon={<PhoneIcon />}
                  isPhnNo={true}
                  label=" Phone Number"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <FormInputField
                  placeholder="Enter email address"
                  formik={formik}
                  name="email"
                  label="Email Address"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <StyledTypographyLLc>Address Details</StyledTypographyLLc>
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <FormInputField
                  placeholder="Enter address"
                  formik={formik}
                  name="address"
                  label="Address"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <SelectInputField
                  formik={formik}
                  placeholder="Select Country"
                  label="Country"
                  menuData={countryList}
                  name="country"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                {formik.values.country && formik.values.country === 233 ? (
                  <SelectInputField
                    formik={formik}
                    placeholder="Select State"
                    label="State"
                    menuData={stateList}
                    name="state"
                    isCheckbox={true}
                    isState={true}
                    disabled={!isEditing}
                    sendValue={true}
                  />
                ) : (
                  <FormInputField
                    placeholder="Enter state"
                    formik={formik}
                    name="state"
                    label="State"
                    disabled={!isEditing}
                  />
                )}
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <FormInputField
                  placeholder="Enter city"
                  formik={formik}
                  name="city"
                  label="City"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <FormInputField
                  type="text"
                  placeholder="Enter zip code"
                  formik={formik}
                  name="zip_code"
                  label="Zip code"
                  isZipCode
                  disabled={!isEditing}
                  maxLength={20}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <UploadFileFieldNew
                  title={"Passport"}
                  icon={<UploadIcon />}
                  name="scan_passport"
                  formik={formik}
                  handleFileChange={(e) => handleFileChange}
                  setFilePreview={setFilePreview}
                  filePreview={filePreview}
                  disabled={!isEditing}
                  showInstruction
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <StyledTypographyLLc>Company Details</StyledTypographyLLc>
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <SelectInputField
                  formik={formik}
                  // onChange={handleChange}
                  placeholder="Select Company Members"
                  label="Will your company be single-member or multi-member?"
                  menuData={member}
                  name="company_members"
                  disabled={!isEditing}
                  sendValue
                />
                {formik.values.company_members === "Multimember" && (
                  <Box mt={2}>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                      {formik.values.additional_members?.map(
                        (member: any, index: number) => {
                          const hasError = Array.isArray(apiErrors)
                            ? apiErrors.find((e: any) => e.member === index + 1)
                            : null;
                          return (
                            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                              <Box
                                sx={{
                                  border: hasError
                                    ? "1px solid red"
                                    : "1px solid #E0E0E0",
                                  p: 2,
                                  borderRadius: "12px",
                                  bgcolor: hasError ? "#FFF0F0" : "#F9F9F9",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: 500,
                                    fontSize: "13px",
                                    color: "#7A7A7A",
                                    mb: "2px",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  Member {index + 1}
                                </Typography>
                                <Typography
                                  sx={{ fontWeight: 600, fontSize: "16px" }}
                                >
                                  {member.first_name} {member.last_name}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    color: "#666",
                                    mb: 1,
                                    wordBreak: "break-all",
                                  }}
                                >
                                  {member.email}
                                </Typography>
                                <Box display="flex" gap={2}>
                                  <Typography
                                    onClick={() => handleOpenEditModal(index)}
                                    sx={{
                                      cursor: "pointer",
                                      color: "#2977CC",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      "&:hover": {
                                        textDecoration: "underline",
                                      },
                                    }}
                                  >
                                    Edit
                                  </Typography>
                                  <Typography
                                    onClick={() => handleDeleteMember(index)}
                                    sx={{
                                      cursor: "pointer",
                                      color: "#FF4D4D",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      "&:hover": {
                                        textDecoration: "underline",
                                      },
                                    }}
                                  >
                                    Remove
                                  </Typography>
                                </Box>
                                {hasError && (
                                  <Typography
                                    sx={{
                                      color: "red",
                                      fontSize: "12px",
                                      mt: 1,
                                    }}
                                  >
                                    {hasError.error}
                                  </Typography>
                                )}
                              </Box>
                            </Grid>
                          );
                        },
                      )}
                    </Grid>
                    <CustomButton
                      btnTitle="Add Member"
                      type="button"
                      handleClick={handleOpenAddModal}
                      minwidth="120px"
                    />
                    {formik.values.company_members === "Multimember" &&
                      formik.values.additional_members?.length === 0 && (
                        <Box mt={1}>
                          <Typography sx={{ color: "red", fontSize: "12px" }}>
                            * At least one member is required.
                          </Typography>
                        </Box>
                      )}
                  </Box>
                )}
              </Grid>

              <Grid size={{ xs: 12, md: 4 }}>
                <CommonRadioButton
                  label="Company Type"
                  names="company_type"
                  formik={formik}
                  trueLabel="LLC"
                  falseLabel="C-Corp"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <StyledTypographyLLc>
                  Company Name Preferences
                </StyledTypographyLLc>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <FormInputField
                  placeholder="Enter preferred name "
                  formik={formik}
                  name="preferred_name_1"
                  label="Preferred Name 1"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <FormInputField
                  placeholder="Enter preferred name "
                  formik={formik}
                  name="preferred_name_2"
                  label="Preferred Name 2"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <FormInputField
                  placeholder="Enter preferred name "
                  formik={formik}
                  name="preferred_name_3"
                  label="Preferred Name 3"
                  disabled={!isEditing}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <SelectInputField
                  placeholder="Select Industry Category"
                  formik={formik}
                  label="Industries"
                  menuData={industryCategories}
                  name="industry_category"
                  disabled={!isEditing}
                  onValueChange={handleIndustryCategoryChange}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <SelectInputField
                  placeholder={
                    formik.values.industry_category
                      ? "Select Sub Industry"
                      : "Select a category first"
                  }
                  formik={formik}
                  label="Sub Industry"
                  menuData={industrySubOptions}
                  name="industry_type"
                  disabled={!isEditing || industrySubOptions.length === 0}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 12 }}>
                {formik.values.industry_type === 13 && (
                  <FormInputField
                    placeholder="Enter description"
                    formik={formik}
                    name="business_description"
                    label="Business Description"
                    isMulti={true}
                    rows={4}
                    disabled={!isEditing}
                  />
                )}
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <CommonRadioButton
                  label="Currently Generating Revenue"
                  names="genrating_revenue"
                  formik={formik}
                  trueLabel="Yes"
                  falseLabel="No"
                  disabled={!isEditing}
                />
              </Grid>
              {formik.values.genrating_revenue == true && (
                <Grid size={{ xs: 12, md: 12 }}>
                  <SelectInputField
                    placeholder="Select Annual Revenue"
                    formik={formik}
                    label="Annual Revenue"
                    name="annual_revenue"
                    disabled={!isEditing}
                    menuData={annual_revenue}
                    sendValue
                    // isCheckbox
                  />
                </Grid>
              )}
              <Grid size={{ xs: 12, md: 12 }}>
                <SelectInputField
                  placeholder="Select Employee Count"
                  formik={formik}
                  label="Employee Count"
                  menuData={employees_count}
                  disabled={!isEditing}
                  name="employees_count"
                  sendValue
                  // isCheckbox
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <CommonRadioButton
                  label="US Customers"
                  names="is_us_company"
                  formik={formik}
                  trueLabel="Yes"
                  falseLabel="No"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <FormInputField
                  placeholder="Enter website name"
                  formik={formik}
                  name="website_name"
                  label="Website Name"
                  disabled={!isEditing}
                />
              </Grid>
            </StyledGrid>

            <Box
              sx={{
                marginTop: 2,
                display: "flex",
                justifyContent: "flex-start",
                gap: "20px",
                flexDirection: {
                  xs: "column",
                  sm: "row",
                },
              }}
            >
              {(isViewMode || isEditMode) && (
                <CustomButtonFormStep
                  btnTitle="Back"
                  disabled={submissionLoading}
                  handleClick={() => navigate(-1)}
                  className="me-[10px]"
                  bgColor="#EAF1FA"
                  textColor={"#2977CC"}
                />
              )}
              {isEditing === true && (
                <CustomButton
                  btnTitle={isViewMode || isEditMode ? "Update" : "Submit"}
                  minwidth="191px"
                  type="submit"
                  loading={submissionLoading}
                />
              )}
              <MemberAttachmentModal
                open={openMemberModal}
                closeModal={() => setOpenMemberModal(false)}
                handleClose={() => setOpenMemberModal(false)}
                formik={formik}
                filePreview={memberFilePreview}
                setFilePreview={setMemberFilePreview}
                handleFileChange={handleMemberFileChange}
                onAddMember={handleSaveMember}
                isEditing={editingMemberIndex !== null}
                countryList={countryList}
                stateList={stateList}
              />
            </Box>
          </form>
        </>
      )}
    </>
  );
};

export default Incorporation;
export const StyledGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  width: "100%",

  [theme.breakpoints.up("lg")]: {
    width: "80%",
    flexDirection: "row",
  },
}));
